module.exports = __webpack_public_path__ + "img/gongzhonghao.1e93f302.jpg";